import axios, { AxiosInstance, AxiosRequestHeaders } from 'axios';

import auth from './auth';

function appendHeaderIfAbsent(headers: AxiosRequestHeaders, key: string, value?: string, isGoAuthEmail?: boolean) {
  // gobiz account
  if (isGoAuthEmail) {
    const token = headers.has(key) ? headers[key] : value;

    return token ? headers.set(key, `Bearer ${token}`) : headers;
  }

  return headers.has(key) || typeof value === 'undefined' ? headers : headers.set(key, value);
}

const authAxios: AxiosInstance = axios.create();

authAxios.interceptors.request.use((config) => {
  return auth.getAccessToken().then((token) => {
    const isGoAuthEmail = auth.authType === 'GoAuth-email';

    config.headers = appendHeaderIfAbsent(config.headers, 'Authorization', token, isGoAuthEmail);

    return config;
  });
});

export { authAxios as axios, appendHeaderIfAbsent as _appendHeaderIfAbsent };
